var map = {
	"./menu-ang/menu-modry-mlin-ang_page-0002.jpg": 6583,
	"./menu-ang/menu-modry-mlin-ang_page-0003.jpg": 498,
	"./menu-ang/menu-modry-mlin-ang_page-0004.jpg": 2512,
	"./menu-ang/menu-modry-mlin-ang_page-0005.jpg": 1131,
	"./menu-ang/menu-modry-mlin-ang_page-0006.jpg": 7102,
	"./menu-ang/menu-modry-mlin-ang_page-0007.jpg": 3786,
	"./menu-ang/menu-modry-mlin-ang_page-0008.jpg": 8061,
	"./menu-pol/menu-modry-mlin-pol_page-0002.jpg": 2013,
	"./menu-pol/menu-modry-mlin-pol_page-0003.jpg": 5866,
	"./menu-pol/menu-modry-mlin-pol_page-0004.jpg": 2838,
	"./menu-pol/menu-modry-mlin-pol_page-0005.jpg": 6838,
	"./menu-pol/menu-modry-mlin-pol_page-0006.jpg": 9410,
	"./menu-pol/menu-modry-mlin-pol_page-0007.jpg": 4318,
	"./menu-pol/menu-modry-mlin-pol_page-0008.jpg": 6298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5990;